import React,{useEffect, useState} from 'react'

import {Container,Row,Col,Form,Button} from 'react-bootstrap'
import Card  from '../../../components/Card'
import {useHistory} from 'react-router-dom'

import Swal from 'sweetalert2'
import axios from 'axios'
import JsonWebToken from '../../../router/auth/JsonWebToken'
import CategoryTable from '../../../database/table/category'
import ActorsTable from '../../../database/table/actors'
import Attachment from '../../../database/table/attachments'

import makeAnimated from 'react-select/animated';
// import { colourOptions } from './docs/data';

const Attachment_ = new Attachment()

const AddMovie = ({match}) => { 

    const TryRegisterMovie = (e) => {

        e.preventDefault();
   
        let _jwt = new JsonWebToken(localStorage.getItem("auth"));

        const data = new FormData();
        data.append('id', e.target.id.value);
        data.append('idserie', e.target.idserie.value);
        data.append('desname',  e.target.destitle.value);
        data.append('desdescription', e.target.desdescription.value);
        data.append('files', e.target.desfile.files[0]);
        //swal with loading screen
        Swal.fire({
                title: 'Cadastrando...',
                icon: 'warning',
                html: 'Aguarde enquanto validamos os dados...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading()
                    //Axios Call
                    axios({
                        method: 'post',
                        url: process.env.REACT_APP_URL + '/api/attachments/edit',
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Accept': 'application/json'
                        },
                        data : data
                    })
                    .then(function (response) {
                            if(response){
                                Swal.fire({
                                    title: 'Sucesso!',
                                    icon: 'success',
                                    html: 'Filme atualizado com sucesso!',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                    allowEnterKey: false,
                                    showConfirmButton: false,
                                    timer: 2000,
                                }).then((timer) => {
                                    window.location.href = "/manager/list-files/" + response.data;
                                }
                            )}
                    })
                    .catch(function ({response}) {
                        Swal.fire({
                            title: 'Erro!',
                            icon: 'error',
                            html: response.data.message ,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            allowEnterKey: false,
                            showConfirmButton: false,
                            timer: 2000
                        })
                    });
                }
            })
        
    }

   //when a file is uploaded in #file input run this function
   const handleFileUpload = (e) => {
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.onloadend = () => {
            // console.log('fim');
        }
        if (file) {
              document.getElementById('gallery2').innerHTML = file.name;
        }
    }
 
    let history = useHistory()
    const [currentAttach, setcurrentAttach] = useState([]);
        
    useEffect( () =>{ 
        Attachment_.getUnique(match.params.id).then(res => {
            //convert res to `{value: 'id', label: 'name'}`
            if(res[0] == null){
              window.location.href = "/manager/show-list"
            }
            //change input values
            document.getElementById('id').value = res[0].id;
            document.getElementById('idserie').value = res[0].idserie;
            document.getElementById('destitle').value = res[0].desname;
            document.getElementById('desdescription').value = res[0].desdescription;

            setcurrentAttach(res[0])
        })
    }, []);

        return (  
                <> 
                <Container fluid>
                    <Row>
                        <Col sm="12">
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <Card.Header.Title>
                                        <h4 className="card-title">Editando Anexo - "{currentAttach.desname}"  </h4>
                                    </Card.Header.Title>
                                </Card.Header>
                                <Card.Body>
                                    <Form onSubmit={TryRegisterMovie}>
                                        <Row>
                                            <Col lg="12">
                                                <Row>
                                                    <Form.Group className="col-12">
                                                        <Form.Control name="destitle" id="destitle" type="text" placeholder="Título do Filme/Série" required/>
                                                        <Form.Control name="desdescription"  id="desdescription" as="textarea" rows="5" placeholder="Descrição [...]" required></Form.Control>
                                                    </Form.Group>
                                                    <div className="col-12 form_gallery form-group">
                                                        <label id="gallery2" htmlFor="desfile">Alterar Anexo ({currentAttach.desfile})</label>
                                                        <input id="desfile" onChange={handleFileUpload} name="desfile"  className="form_gallery-upload" type="file" accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps,video/*"/>
                                                    </div>

                                                 
                                                    
                                                 
                                                </Row>
                                            </Col>

                                    
                                            <Form.Control id="id" name="id"  type="hidden" required/>
                                            <Form.Control id="idserie" name="idserie"  type="hidden" required/>

                                        </Row>
                                        <Row>




                                            <Form.Group className="col-12">
                                                <Button type="submit" variant="primary btn-block">Editar Anexo</Button>{' '}
                                            </Form.Group>
                                        </Row>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </>
        )
    }

export default AddMovie;